import Vue from 'vue'

import axios from 'axios'
import VueAxios from 'vue-axios'
import JwtDecode from 'jwt-decode'
import Vuex from 'vuex'

import router from '../router'

import { Auth } from '../api/auth'

import { LOGIN, LOGOUT, UPDATE_TOKEN } from './types/index'

Vue.use(Vuex)
Vue.use(VueAxios, axios)

const state = {
  token: localStorage.getItem('token') || '',
  user: localStorage.getItem('user') !== 'undefined' ? JSON.parse(localStorage.getItem('user')) : '',
  isLoading: false
}

const mutations = {
  [LOGIN] (state, payload) {
    localStorage.setItem('user', JSON.stringify(payload.user))
    state.user = payload.user
    state.isAuthenticated = true
  },
  [LOGOUT] (state) {
    state.token = null
    state.user = null
    localStorage.removeItem('token')
    localStorage.removeItem('user')
    localStorage.removeItem('client')
    router.push('/auth/login')
  },
  [UPDATE_TOKEN] (state, newToken) {
    localStorage.setItem('token', newToken)
    state.token = newToken
  },
}

const getters = {
  isAuthenticated (state) {
    return !(state.token === undefined || state.token === null || state.token === '')
  },
  authState (state) {
    return (state.user === null || state.user === undefined) ? 'guest' : 'user'
  }
}

function hasGroup (groups, groupName) {
  return groups.findIndex((element) => {
    return element['name'] === groupName
  }) >= 0
}

const actions = {
  login ({commit}, payload) {
    return Auth.obtainToken(payload.credential)
      .then(response => {
        console.log(response)
        if (response.token) {
          let mutationPayload = {
            token: response.token,
            user: response.user,
            redirect: payload.redirect
          }
          commit(UPDATE_TOKEN, response.token)
          commit(LOGIN, mutationPayload)
          let isManager = hasGroup(response.user.groups, 'manager')
          let isClient = hasGroup(response.user.groups, 'client')
          if (isManager) {
            router.push('/manager')
          } else if (isClient) {
            router.push('/client')
          } else {
            router.push('/auth/login')
          }
          return response
        }
      })
      .catch((error) => {
        console.log(error)
        return {'error':true}
      })
  },
  [LOGOUT] ({commit, dispatch}) {
    console.log(dispatch)
    return new Promise(() => {
      delete axios.defaults.headers.common['Authorization']
      commit(LOGOUT)
    })
  },
  refreshToken () {
    const tokenInfo = {
      token: this.state.auth.token
    }
    Auth.refreshToken(tokenInfo)
      .then((response) => {
        console.log('Auth.refreshToken')
        console.log(response)
        localStorage.setItem('user', JSON.stringify(response.user))
        this.commit([UPDATE_TOKEN], response.token)
      })
      .catch((error) => {
        console.log(error)
      })
  },
  inspectToken () {
    const token = this.state.auth.token
    if (token) {
      const decoded = JwtDecode(token)
      const exp = decoded.exp
      if (exp - (Date.now() / 1000) < 5) {
        router.push('/auth/login')
      }
    }
  }
}

export default {
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
}
